import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { concat } from '@ember/helper';
import BvBadge from 'volta/components/bv-badge';
import tElse from 'volta/helpers/t-else';
import type { TOC } from '@ember/component/template-only';
import type { TTaskType } from 'volta/models/types/tasks';
import { t } from 'ember-intl';
interface TaskTypeBadgeSignature {
    Args: {
        taskType?: TTaskType;
    };
    Element: HTMLSpanElement;
}
const getColor = (taskType?: TTaskType)=>{
    if (taskType === 'EXECUTION_TASK') {
        return 'green';
    } else if (taskType === 'PLANNING_TASK') {
        return 'blue';
    } else {
        return 'primary';
    }
};
const TaskTypeBadge: TOC<TaskTypeBadgeSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <BvBadge
    @text={{t (if @taskType (concat 'tasksPage.types.' @taskType) 'task')}}
    @color={{getColor @taskType}}
    ...attributes
  />
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default TaskTypeBadge;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'TasksKit::TaskTypeBadge': typeof TaskTypeBadge;
        'tasks-kit/task-type-badge': typeof TaskTypeBadge;
    }
}
